<crm-multi-select
  [options]="projects"
  [(selectedItems)]="selectedProjects"
  (selectedItemsChange)="selectedProjectsChange.emit($event)"
  [virtualScroll]="true"
  [virtualScrollItemSize]="70"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  scrollHeight="200px"
  [disabled]="disabled"
  [appendTo]="appendTo"
  filterBy="name">
  <ng-template
    #itemTemplate
    let-project="item">
    <ng-container *ngIf="toProject(project) as project">
      <div class="flex flex-grow-1 justify-content-between align-items-center white-space-normal gap-2">
        <div>
          <p class="font-bold">{{ project.name }}</p>
          <p
            *ngIf="project.deadline"
            class="font-medium">
            {{ project.deadline | date: 'dd.MM.yyyy' }}
          </p>
          <p class="font-medium text-green-500">{{ project.responsible?.name }}</p>
        </div>
        <div class="white-space-nowrap">
          <crm-status-label
            *ngIf="project.status"
            [name]="project.status.name"
            [color]="project.status.color"></crm-status-label>
        </div>
      </div>
    </ng-container>
  </ng-template>
</crm-multi-select>
